import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Search } from 'lucide-react';
import classes from "./CurrencyRate.module.css";
import plus from "../../../Assets/plus.svg"
import download from "../../../Assets/download1.svg"
import upload from "../../../Assets/upload.svg"
import EyeIcon from "../../../Assets/new-eye.svg";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import { Spinner, Badge, Button, Modal, Form } from 'react-bootstrap';

// import HeaderNav from "../../Accoungting/HeaderNav/HeaderNav";
// import AdminNav from "../AdminHeaderNav/AdminNav";
import axios from "axios";
import { BASE_URL } from "../../../Components/Styles/API/API";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import Swal from "sweetalert2";
import logo from "../../../Assets/rotating-logo.png";
import { Pencil } from 'lucide-react';
import HeaderNav from "../../Budget/Budget Dashboard/HeaderNav/HeaderNav";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { Plus, Trash2 } from "lucide-react";




const CurrencyRate = () => {
  const [fullName, setFullName] = useState("");
  const [fullName1, setFullName1] = useState("");
  const [email, setEmail] = useState("");
  const [email1, setEmail1] = useState("");
  const [phone1, setPhone1] = useState("");
  const [phone, setPhone] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [address, setAddress] = useState("");
  const [office_address, setOfficeAddress] = useState("");
  const [accName, setAccName] = useState('');
  const [accNo, setAccNo] = useState('');
  const [bankName, setBankName] = useState('');
  const [accName1, setAccName1] = useState('');
  const [accNo1, setAccNo1] = useState('');
  const [bankName1, setBankName1] = useState('');
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [bearer, setBearer] = useState('');
  const [user, setUser] = useState('');
  const [error, setError] = useState(null);
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  // const [totalPages, setTotalPages] = useState(1);
  // const [totalEntries, setTotalEntries] = useState("");
  const [loanCode, setLoanCode] = useState("");
  const [loanDescription, setLoanDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [show1, setShow1] = useState(false);
  const [tableData, setTableData] = useState([]);
  const navigate = useNavigate();
  const [benLoading, setBenLoading] = useState(false);
  const [statLoading, setStatLoading] = useState(false);
  const [stat, setStat] = useState([]);
  const [searchedResult, setSearchedResult] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [showEdit, setShowEdit] = useState(false);
const [editCustomer, setEditCustomer] = useState(null);
const [balance, setBalance] = useState("");
const [selectOptions, setSelectOptions] = useState([]);
const [currency, setCurrency] = useState([]);
const [selectedCurrency, setSelectedCurrency] = useState('');
const [editCurrency, setEditCurrency] = useState(null);
const [exchangeRate, setExchangeRate] = useState('');
const [rates, setRates] = useState('');
const [currLoading, setCurrLoading] = useState(false);
const [selectedCurrencies, setSelectedCurrencies] = useState([]);
const [rows, setRows] = useState([{ currency: null, rate: "" }]);


  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');

      if (value !== null) {
        setBearer(value);
      }
      if (value1 !== null) {
        setUser(value1);
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };


  const handleClose1 = () => setShow1(false);
  const handleClose2 = () => setShow2(false);

const handleShowEdit = (customer) => {
  setEditCustomer(customer); // load selected customer
  setShowEdit(true);
};

const handleCloseEdit = () => {
  setShowEdit(false);
  setEditCustomer(null);
};
  const handleShow = () => setShow(true);
const handleShow2 = (customer) => {
  setSelectedCustomer(customer); // save selected customer
  setShow2(true); // open modal
};
  const handleShow1 = () => setShow1(true);
  const handleClose = () => setShow(false);

  const FetchRates = async () => {
    setBenLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/exchange-rate`, { headers });
      const results = response.data?.data;
      const resultx = response.data?.data?.total;
      // setTotalEntries(resultx);
      setTableData(results);
      // const total = response.data?.data?.last_page || 1;
      // setTotalPages(total);

    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            console.log(errorMessage);
            setError(errorMessage)
          }
        }
        setTableData([]);
      }
    } finally {
      setBenLoading(false);
    }

  };

  useEffect(() => {
    if (bearer) {
      FetchRates();
    }
  }, [bearer, currentPage]);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  // const handlePrevPage = () => {
  //   setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
  // };

  // const handleNextPage = () => {
  //   setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
  // };

  // const formattedTotalEntries = totalEntries.toLocaleString();

  // const fetchStat = async () => {
  //   setStatLoading(true);
  //   try {
  //     const response = await axios.get(`${BASE_URL}/customer/total-customers`, { headers });
  //     const stas = response.data?.data;

  //     setStat(stas);

  //   } catch (error) {
  //     if (error.response && error.response.status === 401) {
  //       navigate('/login');
  //     } else {
  //       let errorMessage = 'An error occurred. Please try again.';
  //       if (error.response && error.response.data && error.response.data.message) {
  //         if (typeof error.response.data.message === 'string') {
  //           errorMessage = error.response.data.message;
  //         } else if (Array.isArray(error.response.data.message)) {
  //           errorMessage = error.response.data.message.join('; ');
  //         } else if (typeof error.response.data.message === 'object') {
  //           console.log(errorMessage);
  //         }
  //       }
  //       setStat([]);
  //     }
  //   } finally {
  //     setStatLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   if (bearer) {
  //     fetchStat();

  //   }
  // }, [bearer]);

  const formatStat = (value) => {
    if (value == null) return "";

    if (value >= 1000 && value < 1000000) {
      const rounded = value / 1000;
      // If divisible by 1000 exactly, no decimals (30k)
      if (value % 1000 === 0) {
        return `${rounded}k`;
      }
      // Else show 2 decimals (30.01k)
      return `${rounded.toFixed(2)}k`;
    }

    if (value >= 1000000) {
      const rounded = value / 1000000;
      if (value % 1000000 === 0) {
        return `${rounded}M`;
      }
      return `${rounded.toFixed(2)}M`;
    }

    // smaller than 1000 → just locale string with commas
    return value.toLocaleString("en-US");
  };

  

  const createCustomer = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to create this customer?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Create",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true); // show rotating logo overlay
        try {
          const response = await axios.post(
            `${BASE_URL}/customer/add`,
            {
              name: fullName,
              email: email,
              phone: phone,
              address: address,
              office_address: office_address,
              account_name: accName,
              account_number: accNo,
              bank_name: bankName,
            },
            { headers }
          );

          // handleCustomers();
          handleClose();

          Swal.fire({
            title: "Success!",
            text: response.data.message,
            icon: "success",
            confirmButtonText: "OK",
          });
        } catch (error) {
          let errorMessage = "Something went wrong.";
          if (error.response && error.response.data.message) {
            errorMessage =
              typeof error.response.data.message === "string"
                ? error.response.data.message
                : JSON.stringify(error.response.data.message);
          }

          Swal.fire({
            title: "Error!",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
        } finally {
          setLoading(false); // hide rotating logo
        }
      }
    });
  };

    const uploadExcel = async () => {
   Swal.fire({
      title: "Are you sure?",
      text: "Do you want to upload this document?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Upload",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setUploading(true);
      try {
        const formData = new FormData();
      formData.append('file', selectedFile[0]);
     
  
      const headers = {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${bearer}`,
      };
  
     
      const response = await axios.post(`${BASE_URL}/customer/import-customer?category_id=${1}`,
        formData,
        { headers }
      );
  handleClose1();
  // handleCustomers();
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });
  
      console.log(response.data.message);
       } catch (error) {
          let errorMessage = "Something went wrong.";
          if (error.response && error.response.data.message) {
            errorMessage =
              typeof error.response.data.message === "string"
                ? error.response.data.message
                : JSON.stringify(error.response.data.message);
          }
  
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: errorMessage,
      });
  
      console.error(error);
    } finally {
          setUploading(false);
        }
      }
    });
  };

  const fetchRates = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/exchange-rate`, { headers });

      console.log(response);
      const results = response.data?.data;
      setTableData(results);
      console.log(results, "reponse");
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      }else{
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
            if (typeof error.response.data.message === 'string') {
                errorMessage = error.response.data.message;
            } else if (Array.isArray(error.response.data.message)) {
                errorMessage = error.response.data.message.join('; ');
            } else if (typeof error.response.data.message === 'object') {
                errorMessage = JSON.stringify(error.response.data.message);
            }
        }
      setTableData([]);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchRates();
    
    }
  }, [bearer]);

  const startIndexx = (currentPage - 1) * entriesPerPage + 1;
  const term = searchTerm?.toLowerCase() || "";
  // const filteredData = tableData?.filter(item =>
  //   (item?.currency?.currency || "").toLowerCase().includes(term)
  // ) || [];
  const filteredData = tableData?.filter(item => {
    const search = term.toLowerCase();
  
    return (
      (item?.currency?.currency || "").toLowerCase().includes(search) ||
      (item?.converted_currency?.currency).toLowerCase().includes(search) ||
      (item?.currency?.country || "").toLowerCase().includes(search) ||
      String(item?.exchange_rate || "").toLowerCase().includes(search) ||
      (item?.specify_by?.name || "").toLowerCase().includes(search) ||
      (formatDate(item?.created_at) || "").toLowerCase().includes(search)
    );
  }) || [];
const totalEntries = filteredData.length;
const endIndexx = Math.min(startIndexx + entriesPerPage - 1, totalEntries);
const displayedData = filteredData.slice(startIndexx - 1, endIndexx);
const totalPages = Math.ceil(filteredData.length / entriesPerPage);
const formattedTotalEntries = totalEntries.toLocaleString();

const handlePrevPage = () => {
  setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
};

const handleNextPage = () => {
  setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
};

const handleCurrencyChange = (selectedOption) => {
  setSelectedCurrency(selectedOption.value);
};

const createRate = async () => {
  setLoading(true);
  const getRates = () => rows.map(r => r.rate);
  const getCurrency = () => rows.map(r => r.currency);


  try {
    console.log(selectedCurrency, getRates, selectedCurrencies, "currencies");

    const response = await axios.post(
      `${BASE_URL}/exchange-rate/create`,
      {
        currency_type: selectedCurrency,
        converted_currency: getCurrency(),
        exchange_rate: getRates()
      },
      { headers }
    );
 
    fetchRates();
    handleClose();
 
    // toast.success(response.data.message);
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message,
    }).then(() => {
      window.location.reload();
    });
    console.log(response);

  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
              if (typeof error.response.data.message === 'string') {
                  errorMessage = error.response.data.message;
              } else if (Array.isArray(error.response.data.message)) {
                  errorMessage = error.response.data.message.join('; ');
              } else if (typeof error.response.data.message === 'object') {
                  errorMessage = JSON.stringify(error.response.data.message);
              }
              // toast.error(errorMessage);
              Swal.fire({
                icon: 'error',
                title: 'Failed',
                text: JSON.stringify(error.response.data.message),
              });
              console.log(errorMessage);
          }
  } finally {
    setLoading(false);
  }
};

const fetchCurrency = async () => {
  setCurrLoading(true);
  try {
    const response = await axios.get(`${BASE_URL}/fetch-all-currencies`, { headers });
    const results = response.data?.data;
      // console.log(results, "currencis")
    const options = results.map((item) => ({
      label: item.code,
      value: item.id,
      symbol: item.symbol,
      country: item.country
    }));
    setCurrency(results);
    setSelectOptions(options);
  } catch (error) {
    const errorStatus = error.response?.data?.message;
    console.log(errorStatus);
    setCurrency([]);
  } finally {
      setCurrLoading(false);
  }
};

useEffect(() => {
  if (bearer) {
      fetchCurrency();
  }
}, [bearer]);

const editRates = async (id) => {
  setLoading(true);

  try {
    const response = await axios.post(
      `${BASE_URL}/exchange-rate/update`,
      {
        exchange_rate: exchangeRate,
        id: id
        
      },
      { headers }
    );

    // fetchContinents();
  handleClose1();
  //  toast.success(response.data.message);
  Swal.fire({
    icon: 'success',
    title: 'Success',
    text: response.data.message,
  }).then(() => {
    window.location.reload();
  });

    // console.log(response.data);
  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
              if (typeof error.response.data.message === 'string') {
                  errorMessage = error.response.data.message;
              } else if (Array.isArray(error.response.data.message)) {
                  errorMessage = error.response.data.message.join('; ');
              } else if (typeof error.response.data.message === 'object') {
                  errorMessage = JSON.stringify(error.response.data.message);
              }
              // toast.error(errorMessage);
              Swal.fire({
                icon: 'error',
                title: 'Failed',
                text: JSON.stringify(error.response.data.message),
              });
          }
  } finally {
    setLoading(false);
  }
};

const handleEditClick = (id) => {
  const foundItem = tableData.find(item => item.id === id);

  if (foundItem) {
    setEditCurrency(foundItem); // store full object (currency + exchange + id)
    setExchangeRate(foundItem.exchange_rate || '');
    setShow1(true);
  }
};



const addRow = () => {
setRows([...rows, { currency: null, rate: "" }]);
};

const deleteRow = (index) => {
const updated = rows.filter((_, i) => i !== index);
setRows(updated);
};


// const updateRowCurrency = (index, value) => {
// const updated = [...rows];
// updated[index].currency = value;
// setRows(updated);
// };

const updateRowCurrency = (index, selectedOption) => {
  const updated = [...rows];
  updated[index].currency = selectedOption.value;  // store only ID
  setRows(updated);
};


 


const updateRowRate = (index, value) => {
const updated = [...rows];
updated[index].rate = value;
setRows(updated);
};




  return (
    <div >
      <HeaderNav />

      <Modal show={show} onHide={handleClose} size="lg" animation={false}>
                      <Modal.Header closeButton>
                        <Modal.Title>Specify New Rate</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Form style={{ marginTop: 20 }}>
                          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label> Base Currency</Form.Label>
                            <div style={{width: "50%"}}>
                            <Select
                                // value={selectedCurrency}
                                onChange={(selectedOption) => handleCurrencyChange(selectedOption)}
                                options={selectOptions}
                                formatOptionLabel={(option) => (
                                <div style={{ display: "flex", gap: "4px", fontSize: "12px" }}>
                                  <span>{option.label}</span>
                                  <span>-</span>
                                  <span style={{ color: "#888" }}>{option.country}</span>
                                </div>
                              )}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    menu: (provided) => ({
                                    ...provided,
                                    }),
                                }}
                                />
                                </div>
                            
                          </Form.Group>
                          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                          <div style={{display: "flex", justifyContent: "space-between", alignItems: "space-between", marginTop: "15px", marginBottom: '5px'}}>
                            <Form.Label style={{fontSize: "16px"}}>Equivalents</Form.Label>
                            
                          </div>
                            <table className={classes.tableTable}>
            <thead className={classes.tableHeader}>
              <tr>
                <th>#</th>
                <th>Currency</th>
                <th>Rate</th>
                <th style={{cursor: "pointer"}}>
                <Plus onClick={addRow} style={{color: "#ffffff", fontWeight: "bold"}} size={12} />
                  </th>
              </tr>
            </thead>
            {rows.map((row, index) => (
<tr key={index}>
<td>{index + 1}</td>
<td style={{ width: "40%" }}>
<Select
 value={selectOptions.find(opt => opt.value === row.currency) || null}
  onChange={(val) => updateRowCurrency(index, val)}
  options={selectOptions}
formatOptionLabel={(option) => (
<div style={{ display: "flex", gap: "4px", fontSize: "12px" }}>
<span>{option.label}</span>
<span>-</span>
<span style={{ color: "#888" }}>{option.country}</span>
</div>
)}
menuPortalTarget={document.body}
styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
/>
</td>


<td>
<Form.Control
type="text"
value={row.rate}
onChange={(e) => updateRowRate(index, e.target.value)}
/>
</td>


<td style={{ textAlign: "center" }}>
<Button
variant="danger"
onClick={() => deleteRow(index)}
style={{ padding: "4px 8px" }}
>
<Trash2 size={18} />
</Button>
</td>
</tr>
))}
            </table>
                            
                          </Form.Group>
                        </Form>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="danger" onClick={handleClose}>
                          Go back
                        </Button>
                        <Button className={classes.submitButton} onClick={createRate}>
                    {loading ? (
                      <>
                      <Spinner  size='sm' /> 
                      <span style={{ marginLeft: '5px' }}>Specifying New Rate, Please wait...</span>
    </>
  ) : (
                "Specify New Rate"
                      )}
                    </Button>
                      </Modal.Footer>
                    </Modal>

                    <Modal show={show1} onHide={handleClose1} animation={false}>
                      <Modal.Header closeButton>
                      <Modal.Title>{editCurrency ? `Edit ${editCurrency.currency?.currency}` : 'Edit Currency'}</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Form style={{ marginTop: 20 }}>
                        <Form.Group className="mb-3" controlId="exchangeRateInput">
                        <Form.Label>Exchange Rate</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Exchange Rate"
                          value={exchangeRate}
                          onChange={(e) => setExchangeRate(e.target.value)}
                        />
                      </Form.Group>
                        </Form>
                      </Modal.Body>
                              <Modal.Footer>
                                <Button variant="danger" onClick={handleClose1}>
                                  Go back
                                </Button>
                                <Button className={classes.submitButton} onClick={() => editRates(editCurrency?.id)} >
                                  {loading ? ( <> <Spinner  size='sm' />
                                    <span style={{ marginLeft: '5px' }}>
                                      Editing currency, Please wait...
                                    </span>
                                    </>) : ("Save Changes")}
                                </Button>
                               
                            </Modal.Footer>
                          </Modal>


      <div className={classes.topContainer}>
        <div className={classes.topNavBars}>
          <Button className={classes.buttonsNav}>Accounts</Button>
          <Button className={classes.buttonsNav}>Reports</Button>
          <Button className={classes.buttonsNav}>Chart of Account</Button>
          <Button className={classes.buttonsNav}>Register</Button>
        </div>
        <div style={{ marginTop: 24 }} />
        <h3 className={classes.topText}>Manage Currency</h3>
        <p className={classes.prgText}>Add and View Currency Rate</p>
        <div className={classes.subContainer}>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            gap: 16,
            alignItems: 'center'
          }}>
            <div className={classes.searchInputWrapper}>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className={classes.searchInput}
                placeholder="Search Currency..."
              />
              {searchTerm ? (
                <button
                  onClick={() => {
                    setSearchTerm("");
                    setSearchedResult([]);
                  }}
                  className={classes.clearBtn}
                >
                  ✕
                </button>
              ) : (
                <Search className={classes.searchIcon} size={16} />
              )}
            </div>

         
          {/* <div className={classes.statCount}>
            <div className={classes.statConn}>
              <p className={classes.txtHd}>Customers</p>
              <p className={classes.txtHds}>
                {statLoading ? (
                  <Skeleton width={80} height={20} />
                ) : (
                  formatStat(stat?.total_number_of_customers)
                )}
              </p>
            </div>
             </div> */}
             {/* {tableData?.length > 0 && (
  <button className={classes.downBtn}>
    <img src={download} alt="download" /> Download Excel
  </button>
)} */}
          </div>
          <div className={classes.threeBtns}>
          <OverlayTrigger
                    placement="top"
                    className={classes.btndf1}
                    overlay={<Tooltip id="button-tooltip"  className={classes.btndf1}>Click here to add new currency rate</Tooltip>}
                  >
                   <Button variant="success" onClick={handleShow} className={classes.submitButton}> Specify Rate</Button>
                  </OverlayTrigger>
            {/* <a style={{marginLeft: 10}} href="https://account-api.patna.ng/api/v1/download-customer-template" download>
            <button className={classes.downBtn}>
              <img src={download} alt="download" /> Download Template
            </button>
            </a> */}

            {/* <button className={classes.downBtn} onClick={handleShow1}>
              <img src={upload} alt="upload" /> Upload Customer
            </button> */}
            {/* <button className={classes.loanBtn} onClick={handleShow}>
              <img src={plus} alt="plus" /> New Customer
            </button> */}
          </div>

        </div>
        <div className={classes.tableContainer}>
          {/* <div style={{display: "flex", gap: 10, alignItems: 'center'}}> */}
           
          {/* </div> */}
          <table className={classes.tableTable}>
            <thead className={classes.tableHeader}>
              <tr>
                                      <th>#</th>
                                      <th>Base Currency</th>
                                      <th>Converted Currency</th>
                                      <th>Country</th>
                                      <th style={{textAlign: "right"}}>Rate</th>
                                      <th>Specify By</th>
                                      <th>Date</th>
                                      <th>Action</th>
                                    </tr>
            </thead>
            <tbody>
  {benLoading ? (
    // Skeleton loading
    Array(5)
      .fill()
      .map((_, idx) => (
        <tr key={idx}>
          {Array(8)
            .fill()
            .map((_, i) => (
              <td key={i}>
                <Skeleton height={20} style={{ marginBottom: 10 }} />
              </td>
            ))}
        </tr>
      ))
  ) : filteredData.length > 0 ? (
    filteredData.map((item, index) => (
      <tr key={index}>
        <td className={classes.textby} style={{ paddingLeft: 10 }}>{index + 1}</td>
        <td className={classes.textby} style={{ paddingLeft: 10 }}>{item?.currency?.currency}</td>
        <td className={classes.textby} style={{ paddingLeft: 10 }}>{item?.converted_currency?.currency}</td>
        <td className={classes.textby} style={{ paddingLeft: 10 }}>{item?.currency?.country}</td>

        <td className={classes.textby} style={{ textAlign: "right" }}>
          {parseFloat(item.exchange_rate).toLocaleString("en-US", {
            minimumIntegerDigits: 1,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </td>

        <td className={classes.textby} style={{ paddingLeft: 10 }}>{item?.specify_by?.name}</td>
        <td className={classes.textby} style={{ paddingLeft: 10 }}>{formatDate(item?.created_at)}</td>

        <td style={{paddingLeft: "20px"}}>
        {/* <i className="far fa-edit" style={{ color: "#008a4b", backgroundColor: "#28a7451a", padding: 2, borderColor: "#28a7454d", borderRadius: 5, fontSize: 12, }} onClick={() => handleEditClick(item.id)} ></i> */}
          <Pencil
            style={{
              color: "#008a4b",
              backgroundColor: "#28a7451a",
              padding: 2,
              borderColor: "#28a7454d",
              borderRadius: 5,
              width: "20px",
              cursor: "pointer"
            }}
            onClick={() => handleEditClick(item.id)}
          />
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan={7} style={{ textAlign: "center", color: "black" }}>
        No rates found.
      </td>
    </tr>
  )}
</tbody>



          </table>
        
            <div className={classes.paginationStyle}>
              <div className={classes.footerSubOne}>
                <button onClick={handlePrevPage}
                  disabled={currentPage === 1} className={classes.btnFirst}>Prev</button>
                {[...Array(totalPages)].map((_, page) => {
                  // Show only 5 pages or less if available
                  if (page < 5 || page === currentPage - 1 || page === totalPages - 1) {
                    return (
                      <span key={page + 1} className={classes.ftOne}>
                        <button
                          className={`${classes.pageNumber} ${currentPage === page + 1 ? classes.active : ""}`}
                          onClick={() => setCurrentPage(page + 1)}
                        >
                          {page + 1}
                        </button>
                      </span>
                    );
                  }
                })}


                <button className={classes.btnSec} onClick={handleNextPage}
                  disabled={currentPage === totalPages}>Next</button>
              </div>
              <p className={classes.displayPag}>Displaying {`Page ${currentPage} - ${totalPages} pages`} of {formattedTotalEntries} entries</p>
            </div>
        


        </div>
      </div>
      {loading && (
        <div className={classes.overlay}>
          <img src={logo} alt="Loading..." className={classes.spinnerLogo} />
        </div>
      )}
      {uploading && (
        <div className={classes.overlay}>
          <img src={logo} alt="Loading..." className={classes.spinnerLogo} />
        </div>
      )}
    </div>
  )
}

export default CurrencyRate